<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="box" id="map"></div>
</template>
<script setup>
import henandata from "@/js/data";
import henan from "@/js/henan";
import * as echarts from "echarts";
import { onMounted } from "vue";

onMounted(() => {
  let myChart = echarts.init(document.getElementById("map"));
  echarts.registerMap("henan", henan);
  let data = henandata.city;
  let geoCoordMap = henandata.geoCoordMap;
  var convertData = function (data) {
    var res = [];
    for (var i = 0; i < data.length; i++) {
      var geoCoord = geoCoordMap[data[i].name];
      if (geoCoord) {
        res.push({
          name: data[i].name,
          value: geoCoord.concat(data[i].value),
        });
      }
    }
    return res;
  };
  let option = {
    visualMap: {
      min: 0,
      max: 400,
      splitNumber: 4,
      inRange: {
        color: ["#FF1414", "#FFD912", "#1FFF13", "#128CFF"].reverse(),
      },
      textStyle: {
        color: "#fff",
      },
      right: 20,
      bottom: "center",
    },
    layoutCenter: ['35%', '50%'],//位置
    layoutSize: 200, // 大小
    geo: {
      map: "henan",
      label: {
        emphasis: {
          show: false,
        },
      },
      roam: true,
      itemStyle: {
        normal: {
          areaColor: "#307E51",
          borderColor: "#2FD34D",
        },
        emphasis: {
          areaColor: "#2FD34D ",
        },
      },
    },
    series: [
      {
        name: "AQI",
        type: "heatmap",
        coordinateSystem: "geo",
        data: convertData(data),
      },
    ],
    grid: {
      left: "0%",
      top: "20%",
      right: "50%",
      bottom: "1%",
    },
  };
  myChart.setOption(option);
});
</script>
<style lang="scss" scoped>
.box {
  width: 100%;
  height: 100%;
}
</style>
